import React from "react";

function SandClock() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.43585 1.52734C4.02023 1.52734 3.68585 1.86172 3.68585 2.27734C3.68585 2.69297 4.02023 3.02734 4.43585 3.02734H4.68585V3.62109C4.68585 4.88047 5.18585 6.08984 6.07648 6.98047L8.62335 9.52734L6.07648 12.0742C5.18585 12.9648 4.68585 14.1742 4.68585 15.4336V16.0273H4.43585C4.02023 16.0273 3.68585 16.3617 3.68585 16.7773C3.68585 17.193 4.02023 17.5273 4.43585 17.5273H14.9359C15.3515 17.5273 15.6859 17.193 15.6859 16.7773C15.6859 16.3617 15.3515 16.0273 14.9359 16.0273H14.6859V15.4336C14.6859 14.1742 14.1859 12.9648 13.2952 12.0742L10.7484 9.52734L13.2952 6.98047C14.1859 6.08984 14.6859 4.88047 14.6859 3.62109V3.02734H14.9359C15.3515 3.02734 15.6859 2.69297 15.6859 2.27734C15.6859 1.86172 15.3515 1.52734 14.9359 1.52734H4.43585ZM9.68585 10.5867L12.2327 13.1336C12.8421 13.7461 13.1859 14.5711 13.1859 15.4336V16.0273H6.18585V15.4336C6.18585 14.5711 6.5296 13.7461 7.13898 13.1367L9.68585 10.5867ZM9.68585 8.46484L7.13898 5.91797C6.5296 5.30859 6.18585 4.48359 6.18585 3.62109V3.02734H13.1859V3.62109C13.1859 4.48359 12.8421 5.30859 12.2327 5.91797L9.68585 8.46797V8.46484Z"
        fill="#4072C8"
      />
    </svg>
  );
}

export default SandClock;
